<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

// import Uspace from "@/models/uspace";
import { useMaterialsStore } from "@/stores/materials-store";
import type Zone from "@/models/entity/zone";
import type UZone from "@/models/entity/uzone";
import { useCommonStore } from "@/stores/common-store";
import { useEditStore } from "@/stores/edit-store";
import type ModelFile from "@/models/entity/model-file";
import CommonUtils from "@/utils/common-util";
import JSZip from "jszip";
import type * as THREE from "three";
import { SizeType, ZoneTypeCode } from "@/global/enums";
import ZoneSmlWindoor from "@/models/entity/zone-sml-windoor";

const materialStore = useMaterialsStore();
const commonStore = useCommonStore();
const editStore = useEditStore();
const jszip = new JSZip();

const props = defineProps<{
  selectSpace: Zone | null;
}>();


const profileOptions = computed(() => {
  return materialStore.profileOption;
});

const zoneTypeCodeList = computed(() => {
  return commonStore.getCodeList("zoneTypeCode");
});

function calcArea(){
  const aaa = document.getElementById("zonePathArea")?.getAttribute("d");
  const points = [];

  const point1 = aaa?.split("M")[1];
  console.log(point1);
  const point2 = point1?.split(" ") as string[];
  console.log(point2);

  for(let i = 1; i < point2?.length; i++){
    let forward;
    let backword;
    if(i - 1 === 0){
      forward = point2[i - 1];
      backword = point2[i].split("L")[0];
    } else if(i === point2.length - 1){
      forward = point2[i - 1].split("L")[1];
      backword = point2[i].split("z")[0];
    } else {
      forward = point2[i - 1].split("L")[1];
      backword = point2[i].split("L")[0];
    }

    points.push([forward, backword]);
  }
  console.log(points);
  // console.log(SVGPathCommander.shapeToPath(aaa));
  // uspaceInfo.value.area = uspaceInfo.value.horizSize * uspaceInfo.value.vertiSize;
  if(Object.keys(editStore.selectModelInfo as THREE.Object3D).length === 0){
    editStore.setSpaceModelSizePosition();
  }
}

const file = ref();

const modelInfoList = computed(() => {
  return editStore.ModelGroupInfoList;
});


onMounted(() => {
});


function inputModel() {
  const picker = document.querySelector("[name='modelPicker']") as HTMLElement;
  console.log(picker);
  picker?.click();
}

async function changeModel(){
  let model: Blob | null = null;
  const textureList: {name: string, data: Blob}[] = [];

  const zipFiles = await jszip.loadAsync(file.value);

  const zipFileName = Object.keys(zipFiles.files);
  // const zip = a.files.forEach(async (relativePath, zipEntry) => {
  //   await zipEntry.async("blob");
  // });

  for(let i = 0; i < zipFileName.length; i++){
    if(zipFileName[i].toUpperCase().includes(".FBX") === true){
      model = await zipFiles.files[zipFileName[i]].async("blob");
    } else {
      textureList.push({
        name: zipFileName[i],
        data: await zipFiles.files[zipFileName[i]].async("blob")
      });
    }
  }

  editStore.localEditFileInput(model as Blob, textureList, file.value);

  file.value = null;
}

/**
 * 공간 명칭 변경
 * @param zoneName 
 */
function onChangeZoneName(zoneName: string) {

  if(CommonUtils.isNullOrEmpty(props.selectSpace))
    return;

  props.selectSpace.zoneName = zoneName;
  console.log(`textChange => ${zoneName}`);
}

/**
 * 단위공간 원점 변경
 * @param value 
 * @param isY 
 */
function onChangeOrigin(value: number, isY = false) {
  if (CommonUtils.isNullOrEmpty(props.selectSpace))
    return;

  if (isY)
    props.selectSpace.originY = Number(value);
  else
    props.selectSpace.originX = Number(value);
}

/**
 * 단위공간 사이즈 변경
 * @param value 
 * @param sizeType
 */
function onChangeSize(value: number, sizeType: SizeType) {
  if (CommonUtils.isNullOrEmpty(props.selectSpace))
    return;

  switch (sizeType) {
    case SizeType.Horizontal:
      props.selectSpace.horizSize = Number(value);
      break;
    case SizeType.Vertical:
      props.selectSpace.vertiSize = Number(value);
      break;
    case SizeType.Height:

      if (CommonUtils.isNullOrEmpty(props.selectSpace.uzone))
        return;

      props.selectSpace.uzone.ceilHeight = Number(value);
      break;
  }

  props.selectSpace.area = props.selectSpace.horizSize * props.selectSpace.vertiSize;

  if (Object.keys(editStore.selectModelInfo as THREE.Object3D).length === 0) {
    editStore.setSpaceModelSizePosition();
  }
}

/**
 * 면적 변경
 * @param area 
 */
function onChangeArea(area: number) {
  if (CommonUtils.isNullOrEmpty(props.selectSpace))
    return;

  props.selectSpace.area = Number(area);
}

const windoorList = ref([] as ZoneSmlWindoor[]);

const newWindoor = ref(new ZoneSmlWindoor());

function getOptionCode(code: string){
  return commonStore.getOptionTypes(code);
}

const column = ref([
  {name: "창호명", label: "창호명", align:"center" as const, field: "windoorName"},
  {name: "유리종류", label: "유리 종류", align:"center" as const, field: "glassTypeCode"},
  {name: "개수", label: "개수", align:"center" as const, field: "windoorQty"},
]);

function addWindoor(){
  const windoorKeys = Object.keys(newWindoor.value);

  for(let i = 0; i < windoorKeys.length; i++){
    const key = windoorKeys[i] as keyof ZoneSmlWindoor;
    if((newWindoor.value as ZoneSmlWindoor)[key] === undefined ||
       newWindoor.value[key] === null ||
       newWindoor.value[key] === ""
    ){
      alert("빈값이 존재합니다. 모든 내용을 확인해주세요.");
      return;
    }
  }

  windoorList.value.push(newWindoor.value);
  newWindoor.value = new ZoneSmlWindoor();
}

</script>

<template>
  <div class="UspaceRightComponent">
    <q-expansion-item label="공간 정보" header-class="uspaceInfoExpansion" default-opened :dark="false" v-if="!CommonUtils.isNullOrEmpty(props.selectSpace) && !CommonUtils.isNullOrEmpty(props.selectSpace.uzone) && !CommonUtils.isNullOrEmpty(props.selectSpace.zoneTypeCode === ZoneTypeCode.단위존)">
      <q-card>
        <q-card-section class="uspaceRightContents">
            <label>명칭</label>
            <q-input 
            square bg-color="white" 
            :dark="false" type="text" 
            maxlength="30" 
            outlined 
            :model-value="props.selectSpace.zoneName"
            @change="onChangeZoneName($event)"
            placeholder="단위공간 명칭" 
            />          
            
            <label>용도프로필</label>
            <div class="row" :style="{alignItems: 'center'}">
              <q-select
              square
              class="col-7"
              bg-color="white"
              :dark="false"
              outlined
              filled
              v-model="props.selectSpace.uzone!.usageProfileCode"
              :options="profileOptions"
              :popup-content-style="{color: '#404040'}"
              label-color="black"
              hide-bottom-space
              options-dense
              emit-value
              map-options
              >
            </q-select>
              <q-checkbox size="30px" class="col-5" v-model="props.selectSpace.uzone!.outdoorYn" :dark="false" label="실외" keep-color color="black" :true-value="'Y'" :false-value="'N'" dense :style="{marginBottom: '10px', justifyContent: 'center'}"/>
            </div>

            <label>선택 모델 그룹</label>
            <div>
              <q-select
              square
              class="col-7"
              bg-color="white"
              :dark="false"
              outlined
              v-model="props.selectSpace.modelFileGrp"
              :options="modelInfoList"
              :popup-content-style="{color: '#404040'}"
              hide-bottom-space
              options-dense
              emit-value
              map-options
              :disable="Object.keys(editStore.selectModelInfo as THREE.Object3D).length === 0"
              >
              </q-select>
            </div>

            <!-- <label>공간 타입</label>
            <div>
              <q-select
              square
              class="col-7"
              bg-color="white"
              :dark="false"
              outlined
              v-model="props.selectSpace.zoneTypeCode"
              :options="zoneTypeCodeList"
              :popup-content-style="{color: '#404040'}"
              option-label="codeName"
              option-value="code"
              hide-bottom-space
              options-dense
              emit-value
              map-options
              >
              </q-select> -->
            <!-- </div> -->

            <div v-if="!CommonUtils.isNullOrEmpty(editStore.selectSiteInfo) && editStore.selectSiteInfo.siteClsfyCode === 'A001'">
                <label>모델 파일</label>
                <div class="row" :style="{alignItems: 'center'}">
                <q-input v-if="props.selectSpace.modelFile !== null" square bg-color="white" :dark="false" class="col-10" outlined
                  disable v-model="(props.selectSpace.modelFile as ModelFile).modelFileName">
                </q-input>
                <q-file v-show="props.selectSpace.modelFile === null" name="modelPicker" class="col-10" outlined square hide-hint
                :dark="false" bg-color="white" v-model="file" dense @update:model-value="changeModel" />
                <div class="col-2" :style="{ paddingTop: '5px', paddingBottom: '5px', marginBottom: '10px' }">
                  <q-btn class="fit" dense outline @click="inputModel">첨부</q-btn>
                </div>            
              </div>
            </div>
            
            <label>원점 [m]</label>
            <div class="row horizonBorderClass">
              <label class="col-3" :style="{margin: '0px'}">X</label>
              <q-input square bg-color="white" :dark="false" class="col-3" dense type="number" outlined :model-value="props.selectSpace.originX" @change="onChangeOrigin($event)" placeholder="X" :style="{marginBottom: '0px'}"/>
              
              <label class="col-3" :style="{margin: '0px'}">Y</label>
              <q-input square bg-color="white" :dark="false" class="col-3" dense type="number" outlined :model-value="props.selectSpace.originY" @change="onChangeOrigin($event, true)" placeholder="Y" :style="{marginBottom: '0px'}"/>
            </div>
            
            <label>크기 [m]</label>
            <div class="horizonBorderClass" :style="{padding:' 10px'}">
              <label class="col-3" style="margin-top: 6px">실 길이</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined :model-value="props.selectSpace.horizSize" placeholder="가로" @change="onChangeSize($event, SizeType.Horizontal)" />
              <label class="col-3" style="margin-top: 6px">실 깊이</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined :model-value="props.selectSpace.vertiSize" placeholder="세로" @change="onChangeSize($event, SizeType.Vertical)"/>
            </div>
            
            <label>면적</label>
            <div class="borderClass">
              <div>
                <label class="col-4">바닥 면적 [㎡]</label>
                
                <q-input square bg-color="white" :dark="false" class="col-4" type="number" outlined :model-value="props.selectSpace.area" @change="onChangeArea($event)" placeholder="면적"/>
                
                <label class="col-4">천장고 [m]</label>
                
                <q-input square bg-color="white" :dark="false" class="col-4" type="number" outlined :model-value="props.selectSpace.uzone.ceilHeight" @change="onChangeSize($event, SizeType.Height)" placeholder="천장고" />
              </div>
            </div>
            
            <label>야간 운영 방식</label>
            <div>
              <q-select
              square
              bg-color="white"
              :dark="false"
              outlined
              v-model="props.selectSpace.uzone.nightOperMode"
              :options="useCommonStore().getOptionTypes('nightOperMode')"
              :popup-content-style="{color: '#000000'}"              
              emit-value
              map-options
              />
            </div>
            <label>주말 운영 방식</label>
            <div>
              <q-select
              square
              bg-color="white"
              :dark="false"
              outlined
              v-model="props.selectSpace.uzone.weekendOperMode"
              :options="useCommonStore().getOptionTypes('weekendOperMode')"              
              :popup-content-style="{color: '#000000'}"
              emit-value
              map-options
              />
            </div>

        </q-card-section>
      </q-card>
    </q-expansion-item>
    <q-expansion-item label="창호 정보" header-class="uspaceInfoExpansion" default-opened :dark="false" v-if="!CommonUtils.isNullOrEmpty(props.selectSpace) && !CommonUtils.isNullOrEmpty(props.selectSpace.uzone) && !CommonUtils.isNullOrEmpty(props.selectSpace.zoneTypeCode === ZoneTypeCode.단위존)">
      <q-card>
        <q-card-section class="uspaceRightContents">
          <label>창호 정보</label>
          <div class="horizonBorderClass" :style="{padding: '0'}">
            <q-table 
              flat
              bordered
              square
              :dense="$q.screen.lt.md"
              ref="windoorRef"
              :columns="column" 
              :rows="windoorList" 
              :row-key="'windoorSeq'"
              :no-data-label="'등록된 창호가 없습니다.'" 
              :dark="false" 
              :pagination="{rowsPerPage: 0, rowsNumber: 0}" 
              :rows-per-page-options="[0]" 
              :table-header-class="'SimulationWindoorsTableHeader'"
              class="SimulationWindoorsTable"
              hide-pagination
              >
              <template v-slot:body="props">
                  <tr :id="`windoorRow${props.row.windoorSeq}`" :style="{textAlign: 'center', cursor:'pointer'}">
                      <td>{{props.row.windoorName}}</td>
                      <td>{{commonStore.getFindCodeToName('glassTypeCode',props.row.glassTypeCode)}}</td>
                      <td>{{props.row.windoorQty}}</td>
                      <!-- <td>{{commonStore.getFindCodeToName('blindEquipCode',props.row.blindEquipCode)}}</td> -->
                  </tr>
              </template>
          </q-table>
          </div>

          <label>창호 정보 입력</label>
          <div class="horizonBorderClass row" :style="{padding:' 10px'}">
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">창호명</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="text" outlined v-model="newWindoor.windoorName" placeholder="창호명"  />
            </div>
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">방위</label>
              <q-select class="col-8" square dense outlined v-model="newWindoor.azimuthCode" :options="getOptionCode('azimuthCode')" :dark="false" bg-color="white" :popup-content-style="{color: '#404040'}" map-options emit-value></q-select>
              <!-- <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined :model-value="props.selectSpace.vertiSize" placeholder="세로"/> -->
            </div>
            <div class="col-12 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">유리 종류</label>
              <q-select class="col-8" square dense outlined v-model="newWindoor.glassTypeCode" :options="getOptionCode('glassTypeCode')" :dark="false" bg-color="white" :popup-content-style="{color: '#404040'}" map-options emit-value></q-select>
            </div>
            <div class="col-12 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">차양 작동 방법</label>
              <q-select class="col-8" square dense outlined v-model="newWindoor.blindEquipCode" :options="getOptionCode('blindEquipCode')" :dark="false" bg-color="white" :popup-content-style="{color: '#404040'}" map-options emit-value></q-select>
            </div>
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">가로 크기[m]</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined v-model="newWindoor.horizSize" placeholder="가로"/>
            </div>
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">세로 크기[m]</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined v-model="newWindoor.vertiSize" placeholder="세로"/>
            </div>
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">하단 높이[m]</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined v-model="newWindoor.bottomHeight" placeholder="하단"/>
            </div>
            <div class="col-6 q-py-xs q-px-xs">
              <label class="col-3" style="margin-top: 6px">개수</label>
              <q-input square bg-color="white" :dark="false" class="col-3" type="number" outlined v-model="newWindoor.windoorQty" placeholder="개수"/>
            </div>
            <div class="col-12 row">
              <div class="col-6 q-py-xs q-px-xs">
                <q-btn square dense color="negative" :style="{width: '100%'}">취소</q-btn>
              </div>
              <div class="col-6 q-py-xs q-px-xs">
                <q-btn square dense color="primary" :style="{width: '100%'}" @click="addWindoor">추가</q-btn> 
              </div>
            </div>
          </div>

        </q-card-section>
      </q-card>
    </q-expansion-item>
  </div>
</template>

<style lang="scss">
.UspaceRightComponent {
  .uspaceInfoExpansion {
    background-color: #e2e6f3;
    color: #404040;
    font-size: 15px;
    border-bottom: 1px solid #c1c1c1;
    border-radius: 0px;
    height: 39px;
    .q-item__label {
      font-weight: bold;
    }
  }
  
  .uspaceRightContents {
    padding: 20px;
    background-color: #f2f4fb;
    color: #404040;
    label {
      margin-bottom: 10px;
      font-weight: bold;
    }

    .q-field__native.items-center{
      white-space: nowrap;
      overflow: hidden;
      word-break: break-all;
    }
  }
  
  .q-field--auto-height .q-field__control,
  .q-field--auto-height .q-field__native {
    min-height: 30px;
  }
  
  .q-textarea .q-field__control {
    height: 75px;
  }
  
  .q-textarea .q-field__native {
    resize: none;
    padding-top: 10px;
    height: 75px;
  }
  
  label {
    margin-bottom: 0px;
    font-size: 13px;
  }
  
  .horizonBorderClass {
    padding: 5px 10px 5px 0px;
    margin-bottom: 10px;
    align-items: center;
    background-color: #e2e6f3;
    
    .q-field--outlined .q-field__control {
      height: 30px;
      margin-bottom: 0px;
    }
    
    label {
      font-size: 12px;
      text-align: center;
    }
  }
  
  .borderClass {
    padding: 5px 10px 5px 10px;
    margin-bottom: 10px;
    background-color: #e2e6f3;
    
    
    .q-field--outlined .q-field__control {
      height: 30px;
      margin-bottom: 0px;
    }
    
    .row {
      justify-content: space-around;
      align-items: center;
      
      label {
        font-size: 12px;
      }
    }
  }
}
</style>
